import React, { PureComponent } from 'react';
import Header from './Header';

class Layout extends PureComponent {
  render() {
    return (
      <div className="tm-page">
        <div className="uk-section-default uk-section header-section">
          <Header />
        </div>
        <div className="uk-section-default uk-section uk-section-xsmall content-section">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Layout;
